import styled from 'styled-components';
const LogsItemContainer = styled.div`
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background: var(--primary-background);
  ::-webkit-scrollbar {
    display: none;
  }
`;

export default LogsItemContainer;
